import React from 'react';
import classnames from 'classnames';

import styles from './Breadcrumb.module.scss';

type PageT = {
  label: string;
  url: string;
};

type BreadcrumbT = {
  pages: PageT[];
  onClick: (url: string) => void;
  initialPageText: string;
  initialPageUrl: string;
};

function Breadcrumb({ pages, onClick, initialPageText, initialPageUrl }: BreadcrumbT) {
  const urlClassnames = (index: number) =>
    classnames(styles.breadcrumb_item_url, { [styles.selected]: index === pages.length });

  const onClickHandler = (index: number, url: string) => {
    if (index < pages.length) {
      url && onClick(url);
    }
  };

  return (
    <ul className={styles.breadcrumb}>
      <li className={styles.breadcrumb_item}>
        <a className={styles.breadcrumb_item_url} onClick={() => onClick(initialPageUrl)}>
          {initialPageText}
        </a>
      </li>
      {pages.map((page: PageT, index: number) => (
        <li key={`breadcrumb_item_${index}`} className={styles.breadcrumb_item}>
          <a
            className={urlClassnames(index + 1)}
            onClick={() => onClickHandler(index + 1, page.url)}
          >
            {page.label}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default Breadcrumb;
